import React, { memo } from 'react';
import {
  FormPageInputItemMailRefusalFlagRadio,
  MailRefusalFlagRadioButtonInput,
  MailRefusalFlagPropertyRadio,
} from 'shared';
import { FormFieldInputItemProps } from '../shared';

type Props = Omit<
  FormFieldInputItemProps<
    MailRefusalFlagPropertyRadio,
    FormPageInputItemMailRefusalFlagRadio
  >,
  'onBlur'
> & {
  value: FormPageInputItemMailRefusalFlagRadio['isRefused'];
};

const VALUE_KEY: Extract<
  keyof FormPageInputItemMailRefusalFlagRadio,
  'isRefused'
> = 'isRefused';

export const MailRefusalFlagRadio: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    value = false,
    onChange,
    className,
    errorMessages,
    displayError,
  }) => {
    const { propertyId, inputFormat } = property;
    const handleChange = (refusal: boolean) => {
      onChange(VALUE_KEY, refusal);
    };
    return (
      <MailRefusalFlagRadioButtonInput
        propertyId={propertyId}
        refusal={value}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onChange={handleChange}
        design={design}
        className={className}
        refusalLabel={inputFormat.mailRefusalLabel}
        receptionLabel={inputFormat.mailReceptionLabel}
      />
    );
  },
);
